import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Container, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Redux/Reducers/LoginReducer.ts";
import { useAlert } from "../Components/Alert.tsx";
import "./SideBar.css";
import { RootState } from "../Redux/Store/index.ts";

const SideBar: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showAlert = useAlert();
  const { profilo } = useSelector((state: RootState) => state.login);
  const handleLogout = () => {
    showAlert(
      "danger",
      "Disconnessione",
      "Sei stato disconnesso.",
      "bottom-end",
      1500
    );
    dispatch(logout());
    navigate("/");
  };

  return (
    <Container fluid className="sidebar">
      <Nav className="flex-column nav">
        <Nav.Item as="li">
          <NavLink
            to="/home"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            data-tooltip="Home"
          >
            <img
              src="../../assets/IconHome.svg"
              alt="Home"
              className="svg-icon default"
            />
            <img
              src="../../assets/IconHomeActive.svg"
              alt="Home Active"
              className="svg-icon active-icon"
            />
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <NavLink
            to="/committenti"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            data-tooltip="Clienti"
          >
            <img
              src="../../assets/IconClienti.svg"
              alt="Committenti"
              className="svg-icon default"
            />
            <img
              src="../../assets/IconClientiActive.svg"
              alt="Committenti Active"
              className="svg-icon active-icon"
            />
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <NavLink
            to="/contratti"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            data-tooltip="Contratti"
          >
            <img
              src="../../assets/IconContratti.svg"
              alt="Contratti"
              className="svg-icon default"
            />
            <img
              src="../../assets/IconContrattiActive.svg"
              alt="Contratti Active"
              className="svg-icon active-icon"
            />
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <NavLink
            to="/cantieri"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            data-tooltip="Cantieri"
          >
            <img
              src="../../assets/IconEngineering.svg"
              alt="Cantieri"
              className="svg-icon default"
            />
            <img
              src="../../assets/IconEngineeringActive.svg"
              alt="Cantieri Active"
              className="svg-icon active-icon"
            />
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <NavLink
            to="/eventi"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            data-tooltip="Eventi"
          >
            <img
              src="../../assets/IconBusinessCenter.svg"
              alt="Eventi"
              className="svg-icon default"
            />
            <img
              src="../../assets/IconBusinessCenterActive.svg"
              alt="Eventi Active"
              className="svg-icon active-icon"
            />
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <NavLink
            to="/calendario"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            data-tooltip="Calendario"
          >
            <img
              src="../../assets/IconCalendario.svg"
              alt="Calendario"
              className="svg-icon default"
            />
            <img
              src="../../assets/IconCalendarioActive.svg"
              alt="Calendario Active"
              className="svg-icon active-icon"
            />
          </NavLink>
        </Nav.Item>
        <Nav.Item as="li">
          <NavLink
            to="/scadenze"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
            data-tooltip="Scadenze"
          >
            <img
              src="../../assets/IconClipboardCheck.svg"
              alt="Scadenze"
              className="svg-icon default"
            />
            <img
              src="../../assets/IconClipboardCheckActives.svg"
              alt="Scadenze Active"
              className="svg-icon active-icon"
            />
          </NavLink>
        </Nav.Item>
      </Nav>
      <Nav className="flex-column nav mt-auto">
        {profilo.tipoUtente === "ACCOUNT" && (
          <Nav.Item as="li">
            <NavLink
              to="/impostazioni"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              data-tooltip="Impostazioni"
            >
              <img
                src="../../assets/IconCog.svg"
                alt="Impostazioni"
                className="svg-icon default"
              />
              <img
                src="../../assets/IconCogActive.svg"
                alt="Impostazioni Active"
                className="svg-icon active-icon"
              />
            </NavLink>
          </Nav.Item>
        )}
        <Nav.Item as="li">
          <div
            className="nav-link"
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
            data-tooltip="Logout"
          >
            <img
              src="../../assets/IconLogOut.svg"
              alt="LogOut"
              className="svg-icon"
            />
          </div>
        </Nav.Item>
      </Nav>
    </Container>
  );
};

export default SideBar;
